/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Ask_User_Multiple_ChoiceInputs */



/**
* | output |
* | --- |
* | "Multiple-choice" |
*
* @param {Chat_Ask_User_Multiple_ChoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_multiple_choice = /** @type {((inputs?: Chat_Ask_User_Multiple_ChoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Multiple_ChoiceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehrfachauswahl")
	return /** @type {LocalizedString} */ ("Multiple-choice")
});